import ManageEventFixtures from "./ManageEventFixtures";
export default ManageEventFixtures;
